import { render, staticRenderFns } from "./OfficeItem.vue?vue&type=template&id=53214245&scoped=true&"
import script from "./OfficeItem.vue?vue&type=script&lang=js&"
export * from "./OfficeItem.vue?vue&type=script&lang=js&"
import style0 from "./OfficeItem.vue?vue&type=style&index=0&id=53214245&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53214245",
  null
  
)

export default component.exports